export default defineNuxtPlugin(() => {
    const xsrfToken = useState<string>("xsrfToken");
    const locale = useNuxtApp().$i18n.locale;

    const api = $fetch.create({
        baseURL: "/api/",
        onRequest({ options }) {
            // pass through cookie header to backend
            const cookie = useRequestHeader("cookie");
            if (cookie) options.headers.set("cookie", cookie);
            options.headers.set("CSRF-Token", xsrfToken.value);
            options.query = { lang: locale.value, ...options.query };
        },
    });

    // Expose to useNuxtApp().$api
    return { provide: { api } };
});
